import { Component, OnInit } from '@angular/core';
import {DbnomicsService} from "./dbnomics.service";

import {Chart} from "chart.js";
import 'chartjs-plugin-colorschemes';
import {NbDialogService, NbSidebarService} from "@nebular/theme";
import {DialogComponent} from "../helpers/dialog/dialog.component";


@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  public render = {};
  public req = 'control of corruption morocco';
  public isLoading = false;
  public isLoading2 = false;
  constructor(private dbnomicsService: DbnomicsService,
              private dialogService: NbDialogService,
              private sidebarService: NbSidebarService) { }


  ngOnInit() {
    Chart.defaults.global.plugins.colorschemes.scheme = 'brewer.SetOne3';
    this.refresh();
  }

  refresh() {
    this.isLoading = true;
    this.dbnomicsService.search(this.req).subscribe( d => {
      this.render['search'] = d;
      if(d.length > 0){
        this.render['selected'] = d[0];
        this.refreshSeries(this.render['selected']['provider'], this.render['selected']['code'], this.render['selected']);
      }
      this.isLoading = false;
    });
  }

  refreshSeries(prov, db, item = {}){
    this.render['selected'] = item;
    this.isLoading2 = true;
    this.dbnomicsService.searchDb(prov, db, this.req ).subscribe( d => {
      this.render['catalog'] = d;
      this.isLoading2 = false;
    })
  }

  openInfo(){
    this.dialogService.open(DialogComponent, {context: {
        title: 'Gallery of Economic Indicators',
        desc: 'International investors continuously monitor countries’ marco-economic indicators in order to assess the ' +
          'risk associated with their investments. These indicators are scattered across multiple websites and thus ' +
          'monitoring them takes considerable manual effort. Here, we provide a real-time aggregator of indicators ' +
          'provided by various international organizations including the WorldBank, IMF, African Development Group, ' +
          'Banque Centrale des Etats de l’Afrique de l’Ouest, Food and Agriculture Organization of the United Nations, ' +
          'International Labour Organization, China Africa Research Initiative, South African Reserve Bank and World ' +
          'trade Organization.',
      }});
  }

  toggle() {
    this.sidebarService.toggle(false, 'left');
  }

}
